import { shallowEqual, useSelector } from 'react-redux'
import React from 'react'
import { Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import PresentationCard from '../../../components/card/PresentationCard'
import PropTypes from 'prop-types'
import { getSettingInt } from '../../../utils/SettingUtils'
import { hasValue } from '../../../utils/NumberUtil'
import { DATA_ADD_NEW_DATA, IMPORT_TYPE, STATION_INTEGRATION } from 'traitements/constants/TraitementConstants'
import adesLogo from 'assets/pictures/logos/ades.png'

const getDefaultParams = (stationType, applicationSettings) => {
    switch (stationType) {
        case IMPORT_TYPE.ADES_PIEZO:
            const adesNetworkSetting = getSettingInt(applicationSettings, 'adesPiezoSynchroNetwork')
            return {
                filters: {
                    descriptionImportMode: 'all',
                    selectStationsMode: 'codesMode',
                    syncEvents: true,
                    syncNetworks: true,
                    dontCheckInternalReferences: false,
                    addCodesToADESNetwork: hasValue(adesNetworkSetting),
                    selectedNetwork: adesNetworkSetting,

                },
                dataTypes: [STATION_INTEGRATION, DATA_ADD_NEW_DATA],
            }
        default:
            return { filters: {}, dataTypes: [] }
    }
}

const updateParams = (stationType, applicationSettings, setFilters, setJobDataTypes) => {
    const params = getDefaultParams(stationType, applicationSettings)
    setFilters(params.filters)
    setJobDataTypes(params.dataTypes)
}


const AddPiezoStepStation = ({
    changeStation,
    nextStep,
    setFilters,
    setJobDataTypes,
    setChoices,
}) => {
    const {
        applicationSettings,
    } = useSelector(store => ({
        applicationSettings: store.AdministrationReducer.applicationSettings,
    }), shallowEqual)

    const centerStyle = {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    }

    return (
        <Grid container justifyContent='center' alignItems='center' spacing={3} padding={2}>
            <Grid size={6} >
                <PresentationCard
                    iconComponent={
                        <img
                            className='responsive-img'
                            src={adesLogo}
                            height={70}
                            width={70}
                            style={{
                                textAlign: 'center',
                                display: 'table-cell',
                                verticalAlign: 'middle',
                            }}
                        />}
                    iconContainerStyle={centerStyle}
                    title={i18n.ades}
                    onClick={() => {
                        setChoices(prev => ({
                            ...prev,
                            TYPE: `(${i18n.ades})`,
                        }))
                        changeStation({ stationType: IMPORT_TYPE.PIEZO_PORTAIL })
                        updateParams(IMPORT_TYPE.PIEZO_PORTAIL, applicationSettings, setFilters, setJobDataTypes)
                        nextStep()
                    }}
                    description={i18n.adesDescription}
                />
            </Grid>
        </Grid>
    )
}

AddPiezoStepStation.propTypes = {
    station: PropTypes.object,
    nextStep: PropTypes.func,
    changeStation: PropTypes.func,
    setFilters: PropTypes.func,
    setJobDataTypes: PropTypes.func,
    setChoices: PropTypes.func,
}

export default AddPiezoStepStation